import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import AppNavbar from './Navbar';
import ParticlesBackground from './ParticlesBackground';
import './Education.css';

const Education = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const { isAuthenticated, error, setError, login } = useAuth();
    const [localEmail, setLocalEmail] = useState("");

    useEffect(() => {
        // Prevent keyboard shortcuts
        const preventKeyboardShortcuts = (e) => {
            if (
                (e.ctrlKey || e.metaKey) && 
                (e.key === 's' || e.key === 'u' || e.key === 'p' || e.key === 'c')
            ) {
                e.preventDefault();
            }
        };

        // Prevent right-click
        const preventRightClick = (e) => {
            if (e.target.tagName === 'IMG') {
                e.preventDefault();
            }
        };

        // Prevent drag and drop
        const preventDrag = (e) => {
            if (e.target.tagName === 'IMG') {
                e.preventDefault();
            }
        };

        // Add event listeners
        document.addEventListener('keydown', preventKeyboardShortcuts);
        document.addEventListener('contextmenu', preventRightClick);
        document.addEventListener('dragstart', preventDrag);

        // Cleanup
        return () => {
            document.removeEventListener('keydown', preventKeyboardShortcuts);
            document.removeEventListener('contextmenu', preventRightClick);
            document.removeEventListener('dragstart', preventDrag);
        };
    }, []);

    const handleImageClick = (imageSrc, caption) => {
        setSelectedImage({ src: imageSrc, caption });
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        
        await login(localEmail);
    };

    return (
        <div className="education-page">
            <header className="App-header">
                <AppNavbar />
                <ParticlesBackground />
                <div className="header-content">
                    <h1>Education</h1>
                </div>
            </header>

            <section className="education-section">
                <div className="section-content">
                    <h2>Characteristics of Pullbacks</h2>
                    <div className="text-content">
                        <p>
                            Below are a confluence of the most important factors I've found to help identify increased probability of pullbacks. These should be used in conjunction with other each other. This goes without saying but even if all align, it does NOT guarantee a pullback.
                        </p>
                    </div>
                    
                    {!isAuthenticated && (
                        <div className="chart-container">
                            <div className="analysis-grid blurred">
                                {/* Blurred preview content */}
                                <div className="analysis-column">
                                    <h3>Entropic Model</h3>
                                    <div className="analysis-box">
                                        <div className="image-container">
                                            <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                Content Preview
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="analysis-column">
                                    <h3>GEX</h3>
                                    <div className="analysis-box">
                                        <div className="image-container">
                                            <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                Content Preview
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="analysis-column">
                                    <h3>Price</h3>
                                    <div className="analysis-box">
                                        <div className="image-container">
                                            <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                Content Preview
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="analysis-column">
                                    <h3>Seasonality</h3>
                                    <div className="analysis-box">
                                        <div className="image-container">
                                            <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                Content Preview
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="analysis-column">
                                    <h3>VIX</h3>
                                    <div className="analysis-box">
                                        <div className="image-container">
                                            <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                Content Preview
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="login-overlay">
                                <h2>Subscriber Login</h2>
                                <p>Enter your email to access the site.</p>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={localEmail}
                                        onChange={(e) => setLocalEmail(e.target.value)}
                                        required
                                    />
                                    <button type="submit">Login</button>
                                </form>
                                {error && <p className="error-message">{error}</p>}

                                <iframe
                                    src="https://machinaquanta.substack.com/embed"
                                    title="Substack Subscription Login"
                                    width="480"
                                    height="320"
                                    frameBorder="0"
                                    scrolling="no"
                                ></iframe>
                            </div>
                        </div>
                    )}
                    
                    {isAuthenticated && (
                        <div className="analysis-grid">
                        {/* Entropy Column */}
                        <div className="analysis-column">
                            <h3>Entropic Model</h3>
                            <div className="analysis-box">
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example1.png" 
                                        alt="Entropy Analysis 1" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example1.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example2.png" 
                                        alt="Entropy Analysis 2" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example2.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example3.png" 
                                        alt="Entropy Analysis 3" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example3.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example4.png" 
                                        alt="Entropy Analysis 4" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example4.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example5.png" 
                                        alt="Entropy Analysis 5" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example5.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/entropy-example6.png" 
                                        alt="Entropy Analysis 6" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/entropy-example6.png", "")}
                                    />
                                </div>
                                <ul className="analysis-points">
                                    <li>One of strongest predictors and early detection</li>
                                    <li>Large drops</li>
                                    <li>Flatlining</li>
                                    <li>Lead to increased probability of pullbacks</li>
                                </ul>
                            </div>
                        </div>

                        {/* GEX Column */}
                        <div className="analysis-column">
                            <h3>GEX</h3>
                            <div className="analysis-box">
                                <div className="image-container" data-type="gex">
                                    <img
                                        src="/images/gex-example1.png"
                                        alt="GEX Example 1"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/gex-example1.png", "")}
                                    />
                                </div>
                                <p className="image-source">Source: <a href="https://squeezemetrics.com/monitor/dix" target="_blank" rel="noopener noreferrer">@squeezemetrics.com/monitor/dix</a></p>
                                <ul className="analysis-points">
                                    <li>Lower highs on GEX (blue circles)</li>
                                    <li>Price may make new highs or consolidate (pink circles)</li>
                                    <li>Diverage leads to increased probability of pullback</li>
                                </ul>
                            </div>
                        </div>

                        {/* Price Column */}
                        <div className="analysis-column">
                            <h3>Price</h3>
                            <div className="analysis-box">
                                <div className="image-container">
                                    <img 
                                        src="/images/price-example1.png" 
                                        alt="Price Example 1" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/price-example1.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/price-example2.png" 
                                        alt="Price Example 2" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/price-example2.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/price-example3.png" 
                                        alt="Price Example 3" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/price-example3.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/price-example4.png" 
                                        alt="Price Example 4" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/price-example4.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/price-example5.png" 
                                        alt="Price Example 5" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/price-example5.png", "")}
                                    />
                                </div>
                                <ul className="analysis-points">
                                    <li>Price consolidates for many days/weeks</li>
                                    <li>Tops are not one-day gap ups/downs events</li>
                                    <li>May see gap downs and/or large red candles in this 'process'</li>
                                </ul>
                            </div>
                        </div>

                        {/* Seasonality Column */}
                        <div className="analysis-column">
                            <h3>Seasonality</h3>
                            <div className="analysis-box">
                                <div className="image-container">
                                    <img 
                                        src="/images/^SPX Average Quarterly Returns by Election Cycle since 1990.png" 
                                        alt="SPX Election Cycle Seasonality" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/^SPX Average Quarterly Returns by Election Cycle since 1990.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/^SPX Average Monthly Returns since 1990.png" 
                                        alt="SPX Monthly Seasonality" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/^SPX Average Monthly Returns since 1990.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img 
                                        src="/images/^SPX Average Semi-Monthly Returns since 1990.png" 
                                        alt="SPX Semi-Monthly Seasonality" 
                                        className="analysis-image"
                                        onClick={() => handleImageClick(encodeURI("/images/^SPX Average Semi-Monthly Returns since 1990.png"), "")}
                                    />
                                </div>
                                <ul className="analysis-points">
                                    <li>Watch for alignment of the 'worst' (relatively) quarterly, monthly, semi-monthly periods</li>
                                    <li>This is the least 'scientific' but it is followed by traders</li>
                                </ul>
                            </div>
                        </div>

                        {/* VIX Column */}
                        <div className="analysis-column">
                            <h3>VIX</h3>
                            <div className="analysis-box">
                                <div className="image-container">
                                    <img
                                        src="/images/vix-example1.png"
                                        alt="VIX Example 1"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-example1.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-example2.png"
                                        alt="VIX Example 2"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-example2.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-example3.png"
                                        alt="VIX Example 3"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-example3.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-example4.png"
                                        alt="VIX Example 4"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-example4.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-example5.png"
                                        alt="VIX Example 5"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-example5.png", "")}
                                    />
                                </div>
                                <ul className="analysis-points">
                                    <li>This is the hardest to nail down for timing (VIX can stay 'low' for long time)</li>
                                    <li>Look for higher lows (while price makes new highs or consolidates)</li>
                                    <li>Look for consolidation (while price while price makes new highs)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </section>

            {/* Characteristics of Bottoms Section */}
            <section className="education-section">
                <div className="section-content">
                    <h2>Characteristics of Bottoms</h2>
                    <div className="text-content">
                        <p>
                            Below are some factors that can help identify potential market bottoms. These indicators should be used in conjunction with each other and other factors including market sentiment, economic and macro factors that are not quantified here. As with pullbacks, even if all align, it does NOT guarantee a bottom has formed.
                        </p>
                    </div>
                    
                    {!isAuthenticated && (
                        <>
                            <div className="paywall-blur">
                                <div className="analysis-grid">
                                    <div className="analysis-column">
                                        <h3>GEX</h3>
                                        <div className="analysis-box">
                                            <div className="image-container">
                                                <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                    Content Preview
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="analysis-column">
                                        <h3>VIX</h3>
                                        <div className="analysis-box">
                                            <div className="image-container">
                                                <div style={{width: '100%', height: '200px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999'}}>
                                                    Content Preview
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    
                    {isAuthenticated && (
                        <div className="analysis-grid">
                        {/* GEX Column */}
                        <div className="analysis-column">
                            <h3>GEX</h3>
                            <div className="analysis-box">
                                <div className="image-container" data-type="gex">
                                    <img
                                        src="/images/gex-bottom-example1.png"
                                        alt="GEX Bottom Example 1"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/gex-bottom-example1.png", "")}
                                    />
                                </div>
                                <div className="image-container" data-type="gex">
                                    <img
                                        src="/images/gex-bottom-example2.png"
                                        alt="GEX Bottom Example 2"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/gex-bottom-example2.png", "")}
                                    />
                                </div>
                                <p className="image-source">Source: <a href="https://squeezemetrics.com/monitor/dix" target="_blank" rel="noopener noreferrer">@squeezemetrics.com/monitor/dix</a></p>
                                <ul className="analysis-points">
                                    <li>GEX in/near negative gamma where historical bounces occurred</li>
                                    <li>GEX may make higher lows (divergence)</li>
                                </ul>
                            </div>
                        </div>

                        {/* VIX Column */}
                        <div className="analysis-column">
                            <h3>VIX</h3>
                            <div className="analysis-box">
                                <div className="image-container">
                                    <img
                                        src="/images/vix-bottom-example1.png"
                                        alt="VIX Bottom Example 1"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-bottom-example1.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-bottom-example2.png"
                                        alt="VIX Bottom Example 2"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-bottom-example2.png", "")}
                                    />
                                </div>
                                <div className="image-container">
                                    <img
                                        src="/images/vix-bottom-example3.png"
                                        alt="VIX Bottom Example 3"
                                        className="analysis-image"
                                        onClick={() => handleImageClick("/images/vix-bottom-example3.png", "")}
                                    />
                                </div>
                                <ul className="analysis-points">
                                    <li>VIX may make lower highs while price makes double/triple bottom or new lows (divergence)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </section>

            {/* Image Modal */}
            {selectedImage && (
                <div className="image-modal" onClick={closeModal}>
                    <div className="modal-content" data-type={selectedImage.src.includes('gex') ? 'gex' : ''}>
                        <span className="close-button" onClick={closeModal}>&times;</span>
                        <img src={selectedImage.src} alt={selectedImage.caption} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Education;  